// removed by extract-text-webpack-plugin
module.exports = {"block":"Game__block___3r1fP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Game.css
// module id = 107
// module chunks = 0